/**
 * Load WASM file using fetch (browser environment)
 * @param path - URL or path to the wasm file
 * @returns Response for streaming instantiation
 */
export const WasmLoad = (path: string): Promise<Response> =>
  fetch(new URL(path, import.meta.url))
